import { services } from "../data";

export const BASE_KEYWORDS = [
  "cleaning services in Melbourne",
  "clear choice cleaning",
  "Clear Choice Cleaning Services",
  "cleaning services in Australia",
  "janitorial services in Melbourne",
  "clear choice janitorial services",
  "commercial cleaning Melbourne",
  "residential cleaning Melbourne",
  "professional cleaners Melbourne",
  "cleaning company Melbourne Australia",
];

export const SERVICE_KEYWORDS = services.map(
  (service) => `${service.name.toLowerCase()} Melbourne`
);

export function buildKeywords(extra = []) {
  return [...new Set([...extra, ...BASE_KEYWORDS, ...SERVICE_KEYWORDS])].join(
    ", "
  );
}
